import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import appStore from '@/store/appStore';
import authStore from '@/store/authStore';
import commonStore from '@/store/commonStore';
import deviceStore from '@/store/deviceStore';
import errorStore from '@/store/errorStore';
import progressStore from '@/store/progressStore';
import propertyStore from '@/store/propertyStore';
import resourceStore from '@/store/resourceStore';
import roomStore from '@/store/roomStore';
import searchResultStore from '@/store/searchResultStore';
import sessionStore from '@/store/sessionStore';
import successStore from '@/store/successStore';
import userStore from '@/store/userStore';
import warnStore from '@/store/warnStore';
import yoyakuStore from '@/store/yoyakuStore';

export default new Vuex.Store({
  modules: {
    app: appStore,
    common: commonStore,
    progress: progressStore,
    error: errorStore,
    warn: warnStore,
    success: successStore,
    searchResult: searchResultStore,
    property: propertyStore,
    room: roomStore,
    device: deviceStore,
    resource: resourceStore,
    user: userStore,
    auth: authStore,
    session: sessionStore,
    yoyaku: yoyakuStore,
  },
  getters: {
    common: (state: any) => {
      return state.common;
    },
    progress: (state: any) => {
      return state.progress;
    },
    error: (state: any) => {
      return state.error;
    },
    warn: (state: any) => {
      return state.warn;
    },
    success: (state: any) => {
      return state.success;
    },
    searchResult: (state: any) => {
      return state.searchResult;
    },
    user: (state: any) => {
      return state.user;
    },
    yoyaku: (state: any) => {
      return state.yoyaku;
    },
  },
});
